module.exports = __webpack_public_path__ + "static/media/iconAdd.4f9dd955.svg";